import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { applyTheme, getStoredTheme, watchSystemTheme } from "./theme";
import "@fontsource-variable/inter";
import "./index.css";

// Theme initial anwenden (vor React-Render, damit kein Flash)
applyTheme(getStoredTheme());
watchSystemTheme(() => applyTheme(getStoredTheme()));

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
